import { iconConverter } from "./IconConverter";
class Utils {
    constructor() {
        //function to return only first 3 letters of the day name in uppercase
        this.setSliderHours = (city) => {
            let hoursArray = [];
            let sliderIndex = 0;
            // get last date from forecast1h
            if (city.data.observation) {
                city.data.observation[0].timeline.map(function (timelineElement, index) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                    let selectedTime = timelineElement;
                    selectedTime.date = city.data.observation[0].date;
                    selectedTime.sunriseHour = utils.convertTime(city.data.observation[0].sunrise),
                        selectedTime.sunsetHour = utils.convertTime(city.data.observation[0].sunset),
                        selectedTime.index = index,
                        selectedTime.sliderIndex = sliderIndex,
                        selectedTime.temperature = timelineElement.t,
                        selectedTime.icon = timelineElement.clouds_icon_wwsyn_icon,
                        selectedTime.icon_text_capitalized = utils.capitalizeFirstLetter(timelineElement.clouds_shortText_wwsyn_shortText),
                        selectedTime.time = utils.convertTime(timelineElement.valid),
                        selectedTime.active = timelineElement.active;
                    selectedTime.dateByName = (_a = utils.getDayName(timelineElement.date)) !== null && _a !== void 0 ? _a : '',
                        selectedTime.dateSLO = (_b = utils.convertDate(timelineElement.date)) !== null && _b !== void 0 ? _b : '',
                        selectedTime.arrayLocation = 'observation';
                    selectedTime.dateByName = (_c = utils.getDayName(city.data.observation[0].date)) !== null && _c !== void 0 ? _c : '',
                        selectedTime.dateSLO = (_d = utils.convertDate(city.data.observation[0].date)) !== null && _d !== void 0 ? _d : '',
                        selectedTime.wind_text = (_e = timelineElement.ff_shortText) !== null && _e !== void 0 ? _e : '',
                        selectedTime.wind_speed = (_f = timelineElement.ff_val) !== null && _f !== void 0 ? _f : '',
                        selectedTime.wind = (_g = timelineElement.ddff_icon) !== null && _g !== void 0 ? _g : '',
                        selectedTime.humidity = (_h = timelineElement.rh) !== null && _h !== void 0 ? _h : '',
                        selectedTime.humidity_text = (_j = timelineElement.rh_shortText) !== null && _j !== void 0 ? _j : '',
                        selectedTime.presure = (_k = timelineElement.msl) !== null && _k !== void 0 ? _k : '',
                        selectedTime.presure_text = (_l = timelineElement.pa_shortText) !== null && _l !== void 0 ? _l : '',
                        sliderIndex++;
                    hoursArray.push(selectedTime);
                });
            }
            city.data.forecast1h.map(function (element, index) {
                element.timeline.map(function (timelineElement, index) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    let selectedTime = timelineElement;
                    selectedTime.date = element.date;
                    selectedTime.sunriseHour = utils.convertTime(element.sunrise),
                        selectedTime.sunsetHour = utils.convertTime(element.sunset),
                        selectedTime.time = utils.convertTime(timelineElement.valid),
                        selectedTime.index = index,
                        selectedTime.sliderIndex = sliderIndex,
                        selectedTime.temperature = timelineElement.t,
                        selectedTime.icon = timelineElement.clouds_icon_wwsyn_icon,
                        selectedTime.icon_text_capitalized = utils.capitalizeFirstLetter(timelineElement.clouds_shortText_wwsyn_shortText),
                        selectedTime.active = timelineElement.active;
                    selectedTime.arrayLocation = 'forecast1h';
                    selectedTime.dateByName = (_a = utils.getDayName(element.date)) !== null && _a !== void 0 ? _a : '',
                        selectedTime.dateSLO = (_b = utils.convertDate(element.date)) !== null && _b !== void 0 ? _b : '',
                        selectedTime.wind_text = (_c = timelineElement.ff_shortText) !== null && _c !== void 0 ? _c : '',
                        selectedTime.wind_speed = (_d = timelineElement.ff_val) !== null && _d !== void 0 ? _d : '',
                        selectedTime.wind = (_e = timelineElement.ddff_icon) !== null && _e !== void 0 ? _e : '',
                        selectedTime.humidity = (_f = timelineElement.rh) !== null && _f !== void 0 ? _f : '',
                        selectedTime.humidity_text = (_g = timelineElement.rh_shortText) !== null && _g !== void 0 ? _g : '',
                        selectedTime.presure = (_h = timelineElement.msl) !== null && _h !== void 0 ? _h : '',
                        selectedTime.presure_text = (_j = timelineElement.pa_shortText) !== null && _j !== void 0 ? _j : '',
                        sliderIndex++;
                    hoursArray.push(selectedTime);
                });
            });
            //to je za preverit nekaj ni ok
            const lastValid1hDate = city.data.forecast1h[city.data.forecast1h.length - 1].timeline[city.data.forecast1h[city.data.forecast1h.length - 1].timeline.length - 1].valid;
            city.data.forecast3h.map(function (element, index) {
                element.timeline.map(function (timelineElement, index) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                    if (utils.compareDates(lastValid1hDate, timelineElement.valid)) {
                        let selectedTime = timelineElement;
                        selectedTime.date = element.date;
                        selectedTime.sunriseHour = utils.convertTime(element.sunrise),
                            selectedTime.sunsetHour = utils.convertTime(element.sunset),
                            selectedTime.time = utils.convertTime(timelineElement.valid),
                            selectedTime.index = index,
                            selectedTime.sliderIndex = sliderIndex,
                            selectedTime.temperature = timelineElement.t,
                            selectedTime.icon = timelineElement.clouds_icon_wwsyn_icon,
                            selectedTime.icon_text_capitalized = utils.capitalizeFirstLetter(timelineElement.clouds_shortText_wwsyn_shortText),
                            selectedTime.active = timelineElement.active;
                        selectedTime.dateByName = (_a = utils.getDayName(timelineElement.date)) !== null && _a !== void 0 ? _a : '',
                            selectedTime.dateSLO = (_b = utils.convertDate(timelineElement.date)) !== null && _b !== void 0 ? _b : '',
                            selectedTime.arrayLocation = 'forecast3h';
                        selectedTime.dateByName = (_c = utils.getDayName(element.date)) !== null && _c !== void 0 ? _c : '',
                            selectedTime.dateSLO = (_d = utils.convertDate(element.date)) !== null && _d !== void 0 ? _d : '',
                            selectedTime.wind_text = (_e = timelineElement.ff_shortText) !== null && _e !== void 0 ? _e : '',
                            selectedTime.wind_speed = (_f = timelineElement.ff_val) !== null && _f !== void 0 ? _f : '',
                            selectedTime.wind = (_g = timelineElement.ddff_icon) !== null && _g !== void 0 ? _g : '',
                            selectedTime.humidity = (_h = timelineElement.rh) !== null && _h !== void 0 ? _h : '',
                            selectedTime.humidity_text = (_j = timelineElement.rh_shortText) !== null && _j !== void 0 ? _j : '',
                            selectedTime.presure = (_k = timelineElement.msl) !== null && _k !== void 0 ? _k : '',
                            selectedTime.presure_text = (_l = timelineElement.pa_shortText) !== null && _l !== void 0 ? _l : '',
                            sliderIndex++;
                        hoursArray.push(selectedTime);
                    }
                });
            });
            //function to calculate next five days from today
            let firstDay = hoursArray[0].valid;
            let fifthDayFromToday = new Date(firstDay);
            fifthDayFromToday.setDate(fifthDayFromToday.getDate() + 4);
            let nextFiveDays = hoursArray.filter(function (element, index) {
                let date = new Date(element.valid);
                date.setHours(0, 0, 0, 0); //reset time to 00:00:00
                return date <= fifthDayFromToday;
            });
            return nextFiveDays;
        };
    }
    getShortDayName(dateString) {
        let date = new Date(dateString);
        return date.toLocaleDateString('sl-SL', { weekday: 'short' }).toUpperCase();
    }
    // funkcija ki preverja datum in čas. Če je prvi datum večji od drugega vrne false, če je prvi datum manjši od drugega vrne true, v primeru, da je čas v istem dnevu večji, vrni true drugače vrni false. Uporablja se pri izbiri dneva in ure v sliderju
    compareDates(date1, date2) {
        let date1Date = new Date(date1);
        let date2Date = new Date(date2);
        if (date1Date.getFullYear() > date2Date.getFullYear() ||
            (date1Date.getFullYear() === date2Date.getFullYear() &&
                date1Date.getMonth() > date2Date.getMonth()) ||
            (date1Date.getFullYear() === date2Date.getFullYear() &&
                date1Date.getMonth() === date2Date.getMonth() &&
                date1Date.getDate() > date2Date.getDate())) {
            return false;
        }
        else if (date1Date.getFullYear() === date2Date.getFullYear() &&
            date1Date.getMonth() === date2Date.getMonth() &&
            date1Date.getDate() === date2Date.getDate()) {
            if (date1Date.getHours() >= date2Date.getHours()) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    }
    changeCity(city, data) {
        data.map(function (element, index) {
            if (element.name === city) {
                return element;
            }
        });
    }
    getHour(dateString) {
        let convertedTime = this.convertTime(dateString);
        let seperateTime = convertedTime.split(":")[0];
        return parseInt(seperateTime, 10);
    }
    convertTime(dateString) {
        if (dateString) {
            let newDate = '';
            let date = new Date(dateString);
            if (date.getHours() < 10) {
                newDate = "0" + date.getHours();
            }
            else {
                newDate = "" + date.getHours();
            }
            if (date.getMinutes() < 10) {
                newDate = newDate + ":" + "0" + date.getMinutes();
                if (newDate.indexOf('0') === 0) {
                    newDate = newDate.substring(1);
                }
            }
            else {
                newDate = newDate + ":" + date.getMinutes();
            }
            return newDate;
        }
    }
    convertDate(dateString) {
        if (dateString) {
            let date = new Date(dateString);
            let month = date.getMonth() + 1;
            return date.getDate() + '. ' + month + ". " + date.getFullYear();
        }
    }
    convertDateToReadable(dateString) {
        if (dateString) {
            const formatter = new Intl.DateTimeFormat('sl', { month: 'long', day: 'numeric' });
            let date = new Date(dateString);
            return formatter.format(date);
        }
    }
    getDayName(dateString) {
        let date = new Date(dateString);
        return this.capitalizeFirstLetter(date.toLocaleDateString('sl-SL', { weekday: 'long' }));
    }
    capitalizeFirstLetter(stringName) {
        return stringName.charAt(0).toUpperCase() + stringName.slice(1);
    }
    generatePastHour(dateString, hour) {
        let minusSec = hour * 3600000;
        let date = new Date(dateString);
        let milliseconds = date.getTime() - minusSec;
        let newDate = new Date(milliseconds);
        return newDate.toISOString().replace("Z", "+00:00");
    }
    getCounter(dateString) {
        let date = new Date(dateString);
        let toIso = date.toISOString().split('T')[1].split(':')[0];
        return parseInt(toIso, 10);
    }
    /*getWindLocation(iconName: string) {
      
      let renamed = iconName.replace("heavy", "light")
      renamed = iconName.replace("mod", "light")
      let rotation: string
      switch (renamed) {
   
        case "lightE":
          rotation = "transform: rotate(270deg);"
          break;
        case "lightENE":
          rotation = "transform: rotate(230deg);"
          break;
        case "lightESE":
          rotation = "transform: rotate(300deg);"
          break;
        case "lightN":
          rotation = "transform: rotate(180deg);"
          break;
        case "lightNE":
          rotation = "transform: rotate(220deg);"
          break;
        case "lightNNE":
          rotation = "transform: rotate(200deg);"
          break;
        case "lightNNW":
          rotation = "transform: rotate(165deg);"
          break;
        case "lightNW":
          rotation = "transform: rotate(150deg);"
          break;
        case "lightS":
          rotation = "transform: rotate(0deg);"
          break;
        case "lightSE":
          rotation = "transform: rotate(330deg);"
          break;
        case "lightSSE":
          rotation = "transform: rotate(350deg);"
          break;
        case "lightSSW":
          rotation = "transform: rotate(30deg);"
          break;
        case "lightSW":
          rotation = "transform: rotate(45deg);"
          break;
        case "lightW":
          rotation = "transform: rotate(90deg);"
          break;
        case "lightWNW":
          rotation = "transform: rotate(120deg);"
          break;
        case "lightWSW":
          rotation = "transform: rotate(70deg);"
          break;
        default:
          break;
      }
      return rotation
    }*/
    /**uporabi, pri observation, ker navadno podatka o smeri vetra v angleščini ni */
    convertWindName(iconNameSLO) {
        iconNameSLO = iconNameSLO.toUpperCase();
        let rotation;
        const windArray = [
            { iconName: "V", rotation: "transform: rotate(270deg);" },
            { iconName: "S", rotation: "transform: rotate(180deg);" },
            { iconName: "SV", rotation: "transform: rotate(220deg);" },
            { iconName: "SZ", rotation: "transform: rotate(150deg);" },
            { iconName: "Z", rotation: "transform: rotate(90deg);" },
            { iconName: "J", rotation: "transform: rotate(0deg);" },
            { iconName: "JV", rotation: "transform: rotate(330deg);" },
            { iconName: "JZ", rotation: "transform: rotate(45deg);" }
        ];
        windArray.map(function (windElement) {
            if (iconNameSLO === windElement.iconName) {
                rotation = windElement.rotation;
            }
        });
        if (rotation) {
            return rotation;
        }
        else {
            return "transform: rotate(0deg);";
        }
    }
    getDisplayIcon(iconCode, time, sunrise, sunset) {
        const nightIcons = [
            "0002_sun_thunderstorm",
            "0004_clear_snow",
            "0005_clear_showers",
            "0006_sun_rain_snow",
            "0014_clear_cloudy_mod",
            "0015_clear_cloudy_prev",
            "0016_clear_cloudy_slight",
            "0018_clear_fog_cloudy",
            "0019_clear_fog",
            "0020_clear",
            "0024_clear_hail",
        ];
        let baseIcon = iconConverter.convert(iconCode);
        if (!baseIcon)
            return "";
        if (baseIcon.endsWith(".svg")) {
            baseIcon = baseIcon.replace(".svg", "");
        }
        if (!time || !sunrise || !sunset) {
            return baseIcon;
        }
        // Ensure time formats are HH:MM
        const parseTime = (t) => {
            if (!t)
                return [0, 0];
            const parts = t.split(":");
            if (parts.length >= 2)
                return [parseInt(parts[0]), parseInt(parts[1])];
            return [0, 0];
        };
        const [cH, cM] = parseTime(time);
        const [rH, rM] = parseTime(sunrise);
        const [sH, sM] = parseTime(sunset);
        const curMin = cH * 60 + cM;
        const riseMin = rH * 60 + rM;
        const setMin = sH * 60 + sM;
        let isNight = false;
        // 1 hour (60 mins) buffer: Day starts 60 mins before sunrise, ends 60 mins after sunset.
        if (curMin < (riseMin - 60) || curMin > (setMin + 60)) {
            isNight = true;
        }
        if (isNight && nightIcons.includes(baseIcon)) {
            return `${baseIcon}_night`;
        }
        return baseIcon;
    }
}
export const utils = new Utils();
